import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import type { SkeletonGroupSkin } from '../SkeletonGroup';

export type SkeletonCircleUniDriver = ReturnType<
  typeof skeletonCircleDriverFactory
>;

export const skeletonCircleDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the diameter
     */
    getDiameter: () => base.attr('data-diameter') as Promise<string>,

    /**
     * Gets the skin
     */
    getSkin: () => base.attr('data-skin') as Promise<SkeletonGroupSkin>,
  };
};
